import {IOffice} from "../../../store/offices/types";
import CardOffice from "./CardOffice";
import React from "react";
import {Col} from "reactstrap";

interface ListOfficesProps {
    offices: Array<IOffice>
}

const ListOffices: React.FC<ListOfficesProps> = ({offices}) => {
    return (
        <React.Fragment>
            {offices.map(item => (
                <Col key={item.id} lg="2" md="3" sm="4">
                    <CardOffice name={item.name} prefix={item.prefix}/>
                </Col>
            ))}
        </React.Fragment>
    )
}

export default ListOffices;